import {
    BoxedAccordion,
    BoxedAccordionItem,
    BoxedRow,
    IconChevronLeftRegular,
    IconTachometerRegular,
    NavigationBar,
    Row,
    RowList,
    Stack,
    Text1,
    Text2,
    Text6,
    ThemeVariant,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import navigateParams from '../../../utils/navigation/navigateParams';
import './index.scss';
import { useTranslation } from 'react-i18next';
import ModalCheckSpeed from './modalCheckSpeed';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import Stopper from '../../../components/Stopper';
import { managementEnvironment } from '../../../utils/dataTransformation/environments';
import { useGlobalContext } from '../../../utils/globals/GlobalContext';
import BreadCrumbsWrapper from '../../../components/BreadcrumbsWrapper';

const Fiber: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    let productId: string = params.get('productId')!;
    const size = useWindowSize();
    const { trackingScreenView } = new TrackingEvents();
    const { context } = useGlobalContext();
    const homeDisabled = managementEnvironment().REACT_APP_STOPPER_HOME_DISABLED;

    // @ts-expect-error
    let fiberArray = context?.bundles.map((item) => item.fiber) ?? [];
    fiberArray = [...fiberArray, ...(context?.fibers ?? [])];
    const fiber = fiberArray.find((item) => item.productId === productId);

    const sendToNative = (url: string, type: string, title: string) => {
        if (navigateParams(type, url, { productId, title }, { ...fiber, title }, title)) {
            const navegations: { [key: string]: string } = {
                'modeFlow-backgroundBlue': `${url}?productId=${productId}`,
                modeExternal: url,
            };
            if (type === 'modeFlow-backgroundBlue') {
                navigate(navegations[type]);
            } else if (type === 'modeExternal') {
                window.open(navegations[type], '_blank');
            }
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <div className='fiber-page'>
            <div className='fiber-page__header' style={{ background: skinVars.colors.backgroundBrand }}>
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='fiber-page__header-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('fiber')}
                            />
                        </div>
                        <div className='fiber-page__header-return'>
                            <div
                                className='fiber-page__header-return-cursor'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='fiber-page__header-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.appBarBackground}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='fiber-page__header-breadcrumbs'>
                    <ThemeVariant isInverse>
                        <BreadCrumbsWrapper
                            title={t('fiber')}
                            breadcrumbs={[{ title: t('breadcrumbsHome'), url: '/home' }]}
                        />
                    </ThemeVariant>
                </div>
                <div className='fiber-page__header-speed'>
                    <div className='fiber-page__header-descent'>
                        <Text6 color={skinVars.colors.inverse}>{fiber?.speedDown}</Text6>
                        <Text2 regular color={skinVars.colors.inverse}>
                            {t('descentSpeedFiber')}
                        </Text2>
                    </div>
                    <div className='fiber-page__header-rise'>
                        <Text6 color={skinVars.colors.inverse}>{fiber?.speedUp}</Text6>
                        <Text2 regular color={skinVars.colors.inverse}>
                            {t('uploadSpeedFiber')}
                        </Text2>
                    </div>
                </div>
            </div>
            <div className='fiber-page__content'>
                <div className='fiber-page__content-test'>
                    {size.width >= 1024 ? (
                        <div className='fiber-page__content-test-accordeon'>
                            <BoxedAccordion>
                                <BoxedAccordionItem
                                    title={t('speedTestFiber')}
                                    asset={
                                        <Stack space={8}>
                                            <IconTachometerRegular size={24} />
                                        </Stack>
                                    }
                                    content={<ModalCheckSpeed></ModalCheckSpeed>}
                                />
                            </BoxedAccordion>
                        </div>
                    ) : (
                        <BoxedRow
                            asset={<IconTachometerRegular />}
                            title={t('speedTestFiber')}
                            onPress={() =>
                                sendToNative(
                                    '/fiber/fiber-modal-check-speed',
                                    'modeFlow-backgroundBlue',
                                    t('speedTestFiber'),
                                )
                            }
                        />
                    )}
                </div>
                <div className='fiber-page__content-info'>
                    <div className='fiber-page__content-info-text'>
                        <Text1 medium color={skinVars.colors.textSecondary}>
                            {t('fiberInformation')}
                        </Text1>
                    </div>
                    <div className='fiber-page__content-info-row'>
                        <RowList role='fiberRow'>
                            <Row
                                title={t('speedProblemsFiber')}
                                onPress={() =>
                                    sendToNative(
                                        'https://o2online.es/ayuda/velocidad-fibra-o2-consejos/',
                                        'modeExternal',
                                        '',
                                    )
                                }
                            ></Row>
                            <Row
                                title={t('noInternetRouterFiber')}
                                onPress={() =>
                                    sendToNative(
                                        'https://o2online.es/ayuda/no-me-funciona-internet-router-o2/',
                                        'modeExternal',
                                        '',
                                    )
                                }
                            ></Row>
                            <Row
                                title={t('networkBetterFiber')}
                                onPress={() =>
                                    sendToNative('https://o2online.es/ayuda/wifi-o-wifi-plus/', 'modeExternal', '')
                                }
                            ></Row>
                        </RowList>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Fiber;
